export default __webpack_public_path__ + "maps-examples-approximate-location-1200-4dd26b317fd8da1e6f5e06ee7e175a58.webp";